import { InjectionToken, inject } from '@angular/core';

import { WINDOW } from './window/window.token';

/**
 * A DI Token to safely access the ResizeObserver.
 * In the browser it will resolve to the global ResizeObserver and on the server it will resolve to a stub.
 */
export const RESIZE_OBSERVER = new InjectionToken('ResizeObserverToken', {
    providedIn: 'root',
    factory: () => inject(WINDOW)['ResizeObserver'],
});
